<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :span="8">
        <a-button type="primary" icon="plus" @click="goAddOnSale(1)">批量加价</a-button>
        <a-button style="margin-left: 20px;" icon="minus" @click="goAddOnSale(0)">批量减价</a-button>
      </a-col>
      <!--      <a-col :span="8" :offset="8" style="text-align: right;padding-top: 10px;">-->
      <!--        仅保留6个月内的价格调整记录-->
      <!--      </a-col>-->
    </a-row>
    <custom-page-table
      :queryParams="queryParams"
      style="margin-top:20px;"
      ref="tableList"
      :columns="getColumns()"
      :requestPromise="loadPromise"
    >
    </custom-page-table>
  </a-card>
</template>

<script>
import fliggyMixins from './fliggyMixins'

export default {
  name: 'AddReductionRecord',
  mixins: [fliggyMixins],
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {

  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getServerApiService().post('feizhu/link/queryPushModifyPriceList', params)
    },
    getColumns() {
      return [
        {
          title: '调整时间',
          dataIndex: 'modifyTime'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '28%'
        },
        {
          title: '商家编码(本系统商品ID)',
          dataIndex: 'proId'
        },
        {
          title: '商品类型',
          dataIndex: 'proTypeName'
        },
        {
          title: '飞猪店铺名称',
          dataIndex: 'taoBaoUserNick'
        },
        {
          title: '调整方式',
          dataIndex: 'modifyTypeStr'
        },
        {
          title: '调整内容',
          dataIndex: 'modifyDes'
        }
      ]
    },
    goAddOnSale(type) {
      this.openNewPage('BatchAddOnSale', {
        serverUniqueId: this.$route.query.serverUniqueId,
        serverId: this.$route.query.serverId,
        type: type
      })
    }
  }
}
</script>

<style scoped>

</style>